import React, { useMemo } from "react";
import { Table, Form, Button, Badge } from "react-bootstrap";

// Phase 5, §8/§32. Shows the weight total live and visually flags when it
// is not exactly 100 — activation is blocked server-side regardless, this
// is purely upfront transparency so an Admin isn't surprised by the
// PERFORMANCE_PROFILE_WEIGHT_INVALID error.
export default function PerformanceWeightageEditor({ rows, onChange, onRemove }) {
  const totalWeight = useMemo(
    () => rows.filter((r) => r.include_in_score).reduce((sum, r) => sum + (Number(r.weightage) || 0), 0),
    [rows]
  );

  const update = (index, field, value) => {
    const next = [...rows];
    next[index] = { ...next[index], [field]: value };
    onChange(next);
  };

  return (
    <div>
      <div className="table-responsive">
        <Table size="sm" bordered>
          <thead>
            <tr>
              <th>Metric</th><th>Direction</th><th>Include In Score</th><th>Weightage %</th><th>Mandatory</th><th>Target Override</th><th></th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r, i) => (
              <tr key={r.performance_metric_definition_id}>
                <td>{r.name} <span className="text-muted small">({r.code})</span></td>
                <td>{r.direction === "INFORMATIONAL_ONLY" ? <Badge bg="secondary">Informational</Badge> : r.direction}</td>
                <td><Form.Check type="checkbox" checked={!!r.include_in_score} onChange={(e) => update(i, "include_in_score", e.target.checked)} /></td>
                <td style={{ maxWidth: 100 }}>
                  <Form.Control size="sm" type="number" min="0" max="100" value={r.weightage} disabled={!r.include_in_score} onChange={(e) => update(i, "weightage", e.target.value)} />
                </td>
                <td><Form.Check type="checkbox" checked={!!r.mandatory_data} onChange={(e) => update(i, "mandatory_data", e.target.checked)} /></td>
                <td style={{ maxWidth: 120 }}>
                  <Form.Control size="sm" type="number" value={r.target_value_override ?? ""} placeholder={r.target_value ?? ""} onChange={(e) => update(i, "target_value_override", e.target.value || null)} />
                </td>
                <td><Button size="sm" variant="outline-danger" onClick={() => onRemove(i)}>Remove</Button></td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <div className={`fw-bold ${Math.abs(totalWeight - 100) > 0.01 && rows.some((r) => r.include_in_score) ? "text-danger" : "text-success"}`}>
        Total scored weightage: {totalWeight}% {rows.some((r) => r.include_in_score) && Math.abs(totalWeight - 100) > 0.01 && "(must equal 100 to activate)"}
      </div>
    </div>
  );
}
